import { render, staticRenderFns } from "./relate-product-modal.vue?vue&type=template&id=32430eb8&scoped=true&"
import script from "./relate-product-modal.vue?vue&type=script&lang=js&"
export * from "./relate-product-modal.vue?vue&type=script&lang=js&"
import style0 from "./relate-product-modal.vue?vue&type=style&index=0&id=32430eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32430eb8",
  null
  
)

export default component.exports